class NavigateScripts {
	constructor() {
        ( function ( $ ) {
            // "use strict";
            window.navigateBack = '';
            window.navigateCurrent = `#${$('[role="tabpanel"]:not(.hidden)').attr('id')}`;

            $('.navigation_mobile').on('click', '.navigate_mobile', function() {                
                window.navigateBack = HSTabs.getInstance('#navigation_mobile').prevContentId;
                window.navigateCurrent = HSTabs.getInstance('#navigation_mobile').currentContentId;
                // console.log('Tab anterior:', `#${$('[role="tabpanel"]:not(.hidden)').attr('id')}`);
            });
            $('.back_mobile').on('click', function() {
                HSTabs.getInstance('#navigation_mobile').open(document.querySelector(`${window.navigateBack}-item`));
            });
            $('.gaia_navigate_return').on('click', function() {
                HSTabs.getInstance('#navigation_mobile').open(document.querySelector(`#main-content-item`));
            });
        }( jQuery ) );
    }
}

export default NavigateScripts